export default {
  // getters
  exception: "exception",
  authentication: "authentication",
  waitingRoom: "waiting-room",
  board: "board",
  end: "end",
  // setters
  createGame: "create-game",
  joinGame: "join-game",
  leaveGame: "leave-game",
  startGame: "start-game",
  pickChancellor: "pick-chancellor",
  vote: "vote",
  presidentRejectRule: "president-reject-rule",
  chancellorPassRule: "chancellor-pass-rule",
  makeAbilityDone: "make-ability-done",
  killPlayer: "kill-player",
  requestVeto: "request-veto",
  answerVeto: "answer-veto",
  searchChoose: "search-choose",
  searchDone: "search-done",
  nextPresident: "next-president",
};
